<template>
  <div class="view-box">
    <div class="title-box">
      <div class="title">
        <p class="title2">全国降水落区预报</p>
      </div>
      <div class="map-title-box">
        <span :class="tabcss1?'xzcss':'wxzcss'" @click="btnn(1)">{{ pe }}</span>
        <span :class="tabcss2?'xzcss':'wxzcss'" @click="btnn(2)">{{ poo }}</span>
        <span :class="tabcss3?'xzcss':'wxzcss'" @click="btnn(3)">{{ ppp }}</span>
        <span :class="tabcss4?'xzcss':'wxzcss'" @click="btnn(4)">{{ pll }}</span>
        <span :class="tabcss5?'xzcss':'wxzcss'" @click="btnn(5)">{{ pkk }}</span>
        <span :class="tabcss6?'xzcss':'wxzcss'" @click="btnn(6)">{{ phh }}</span>
        <span :class="tabcss7?'xzcss':'wxzcss'" @click="btnn(7)">{{ pyy }}</span>
      </div>
      <div class="table-box">
        <img id="qg" v-show="hasPic" :src="Qpicturee" :onerror="defaultImg" alt="无预警"
             style=" cursor:hand; width:60%;text-align: center;margin:0 20%">
        <div class="imgg" v-show="!hasPic">
          <i>当前时次无产品</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import default_pic from "../../../assets/image/default_pic.png"

export default {
  data() {
    return {
      defaultImg: default_pic,
      hasPic: true,
      Qpicturee: "",
      Qpicture: "",
      po: "",
      pc: "",
      pa: "",
      ps: "",
      pf: "",
      pd: "",
      pe: "",
      poo: "",
      ppp: "",
      pll: "",
      pkk: "",
      phh: "",
      pyy: "",
      radio: 1, //单选按钮的值
      tabcss1: true,
      tabcss2: false,
      tabcss3: false,
      tabcss4: false,
      tabcss5: false,
      tabcss6: false,
      tabcss7: false

    };
  },
  created: function () {
    this.getTpp();
  },

  methods: {
    getTpp: function () {
      this.$post("RainArea_nation.action")
          .then(body => {
            var TimeS = body.times;
            this.pe = TimeS.split(",")[0];
            this.poo = TimeS.split(",")[1];
            this.ppp = TimeS.split(",")[2];
            this.pll = TimeS.split(",")[3];
            this.pkk = TimeS.split(",")[4];
            this.phh = TimeS.split(",")[5];
            this.pyy = TimeS.split(",")[6];

            var pi = body.Result;
            this.Qpicture = pi[0].url;
            if (this.Qpicture === '') {
              this.hasPic = false;
            } else {
              this.Qpicturee = this.Qpicture;
            }
            this.po = pi[1].url;
            this.pc = pi[2].url;
            this.pa = pi[3].url;
            this.ps = pi[4].url;
            this.pf = pi[5].url;
            this.pd = pi[6].url;
          })
          .catch(error => {
            console.log(error);
            this.hasPic = false;
            //  this.Qpicturee = default_pic;
          });
    },
    btnn(radio) {
      this.radio = radio;
      this.hasPic = true;
      if (this.radio == "1") {
        this.tabcss1 = true;
        this.tabcss2 = false;
        this.tabcss3 = false;
        this.tabcss4 = false;
        this.tabcss5 = false;
        this.tabcss6 = false;
        this.tabcss7 = false;
        if (this.Qpicture === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.Qpicture
        }
      } else if (this.radio == "2") {
        this.tabcss1 = false;
        this.tabcss2 = true;
        this.tabcss3 = false;
        this.tabcss4 = false;
        this.tabcss5 = false;
        this.tabcss6 = false;
        this.tabcss7 = false;
        if (this.po === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.po
        }
      } else if (this.radio == "3") {
        this.tabcss1 = false;
        this.tabcss2 = false;
        this.tabcss3 = true;
        this.tabcss4 = false;
        this.tabcss5 = false;
        this.tabcss6 = false;
        this.tabcss7 = false;
        if (this.pc === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.pc
        }
      } else if (this.radio == "4") {
        this.tabcss1 = false;
        this.tabcss2 = false;
        this.tabcss3 = false;
        this.tabcss4 = true;
        this.tabcss5 = false;
        this.tabcss6 = false;
        this.tabcss7 = false;
        if (this.pa === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.pa
        }
      } else if (this.radio == "5") {
        this.tabcss1 = false;
        this.tabcss2 = false;
        this.tabcss3 = false;
        this.tabcss4 = false;
        this.tabcss5 = true;
        this.tabcss6 = false;
        this.tabcss7 = false;
        if (this.ps === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.ps
        }
      } else if (this.radio == "6") {
        this.tabcss1 = false;
        this.tabcss2 = false;
        this.tabcss3 = false;
        this.tabcss4 = false;
        this.tabcss5 = false;
        this.tabcss6 = true;
        this.tabcss7 = false;
        if (this.pf === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.pf
        }
      } else {
        this.tabcss1 = false;
        this.tabcss2 = false;
        this.tabcss3 = false;
        this.tabcss4 = false;
        this.tabcss5 = false;
        this.tabcss6 = false;
        this.tabcss7 = true;
        if (this.pd === '') {
          this.hasPic = false;
        } else {
          this.Qpicturee = this.pd
        }
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

$height = 30px;

.view-box {
  width: 1000px;
  height: 100%;
  margin: 0 auto;
  padding: 0;


  .title-box {
    height: 100%;
    padding: 6px 6px;

    .title {
      width: 100%;
      height: $height;
      line-height: $height;
      display: flex;
      background: #4595e6;
      color: #ffffff;
      border-top-left-radius: 5px;
      -moz-border-top-left-radius: 5px;
      -webkit-border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      -moz-border-top-right-radius: 5px;
      -webkit-border-top-right-radius: 5px;

      span {
        cursor: pointer;

        img {
          widows: 20%;
          height: 20px;
          margin: 6px;
        }
      }

      .title2 {
        height: $height;
        line-height: $height;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        position: relative;
        padding: 0 12px;
        width: 100%;
      }
    }

    .map-title-box {
      display: flex;
      line-height: $height;
      border-left: 1px solid #eee
      border-right: 1px solid #eee
    }

    .xzcss {
      display: inline-block;
      width: 50px;
      text-align: center;
      font-size: 14px;
      line-height: 50px;
      color: red;
      padding: 0 6px;
      font-weight: bold;
      text-decoration: underline;
      cursor: pointer;
    }

    .wxzcss {
      display: inline-block;
      width: 50px;
      color: #003464;
      text-align: center;
      font-size: 14px;
      line-height: 50px;
      padding: 0 6px;
      font-weight: bold;
      text-decoration: underline;
      cursor: pointer;
    }

    .table-box {
      width: 100%;
      height: auto;
      position: relative;
      border-left: 1px solid #eee
      border-right: 1px solid #eee
      border-bottom: 1px solid #eee

      img {
        width: 100%;
        height: auto;
      }

      p {
        text-align: center;
        size: 20px;
      }

    }
  }
}

.imgg {
  width: 100%;
  height: 100%

  i {
    display: inline-block
    width: 100%
    font: 400 20px / 300px "microsoft yahei"
    text-align: center
  }

}
</style>
